'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useLocalParticipant } from '@livekit/components-react';
import { Track } from 'livekit-client';
import { Button } from './components/ui/button';
export function MuteButton() {
    const { localParticipant } = useLocalParticipant();
    const [muted, setMuted] = useState(false);
    useEffect(() => {
        const publication = localParticipant.getTrackPublication(Track.Source.Microphone);
        setMuted(publication?.isMuted ?? false);
    }, [localParticipant]);
    const toggle = useCallback(async () => {
        const next = !muted;
        await localParticipant.setMicrophoneEnabled(!next);
        setMuted(next);
    }, [localParticipant, muted]);
    return (_jsx(Button, { size: "sm", variant: muted ? 'secondary' : 'outline', onClick: toggle, children: muted ? 'Unmute' : 'Mute' }));
}
//# sourceMappingURL=MuteButton.js.map